import { ThemeInterface, themeNames } from "../theme";
import { colors } from "../../styles/variables";
import { FontNames, FontWeights, HexColor } from "../../types/styles";

type PoppiColorNames = "white" | "magenta" | "darkMagenta" | "lightPink";

// poppi — official brand palette (magenta-first, matching the drinkpoppi.com
// replica pages in apps/poppi/styles/colors.scss: $magenta / $poppi-pink).
export const POPPI_COLORS: Record<PoppiColorNames, HexColor> = {
  white: "#ffffff",
  magenta: "#ec008c", // signature poppi magenta (primary)
  darkMagenta: "#c2007a", // darker magenta for hover/depth
  lightPink: "#ffc7df", // soft pink (accent)
};

const SHARED_HEADING_STYLES = {
  // Toroka display typeface for headlines (H1–H5)
  fontFamily: "font-secondary" as FontNames,
  fontWeight: "700" as FontWeights,
  color: POPPI_COLORS.magenta,
};

export const PoppiTheme: ThemeInterface = {
  name: themeNames.Poppi,
  color: {
    primary: POPPI_COLORS.magenta,
    secondary: POPPI_COLORS.darkMagenta,
    tertiary: POPPI_COLORS.darkMagenta,
    accent: POPPI_COLORS.lightPink,
    disabled: colors.gray300,
    action: colors.green,
    error: colors.red,
    text: colors.gray900,
  },
  button: {
    primary: {
      color: POPPI_COLORS.magenta,
    },
    secondary: {
      color: POPPI_COLORS.darkMagenta,
    },
    tertiary: {
      color: POPPI_COLORS.magenta,
      hollow: true,
    },
    cancel: {
      color: colors.gray600,
      hollow: true,
    },
    error: {
      color: colors.red,
      hollow: true,
    },
    text: {
      color: POPPI_COLORS.magenta,
    },
    disabled: {
      hollow: true,
    },
    fontWeight: "700",
    // Pill-shaped buttons for the playful poppi look
    borderRadius: "100px",
  },
  priceAccentColor: POPPI_COLORS.magenta,
  typography: {
    heading: {
      xxl: {
        fontSize: {
          desktop: "46px",
          mobile: "32px",
        },
        letterSpacing: "-1px",
        ...SHARED_HEADING_STYLES,
        lineHeight: "133%", // H1
      },
      xl: {
        fontSize: {
          desktop: "36px",
          mobile: "24px",
        },
        letterSpacing: "-1px",
        ...SHARED_HEADING_STYLES,
        lineHeight: "100%", // H2
      },
      l: {
        fontSize: {
          desktop: "24px",
          mobile: "20px",
        },
        letterSpacing: "-1px",
        ...SHARED_HEADING_STYLES,
        lineHeight: "110%", // H3
      },
      m: {
        fontSize: {
          desktop: "18px",
          mobile: "18px",
        },
        ...SHARED_HEADING_STYLES,
        lineHeight: "130%", // H4
      },
      s: {
        fontSize: {
          desktop: "16px",
          mobile: "16px",
        },
        ...SHARED_HEADING_STYLES,
        lineHeight: "110%", // H5
      },
      xs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        ...SHARED_HEADING_STYLES,
      },
      xxs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        fontFamily: "font-primary",
        fontWeight: "400",
        color: colors.gray900,
      },
    },
  },
};
